import { css } from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background-color: white;
`;

export const hideScrollbarCss = css`
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;



export const widthCss = css`
    display: flex;
    flex-direction: column;
    width:100%;
    max-width: 1200px;
    padding: 120px 0px;
    margin: 0 auto;
    gap: 120px;
    justify-content: center;

`;


export const widthCss2 = css`
    display: flex;
    /*width: 1200px;*/
    max-width: 1200px;
    width:100%;
    flex-direction: column;
    margin: 0 auto;
    gap: 60px;
    position: relative;
    height: 100%;

    .authorIntro {
        display: flex;
        height: 140px;
        padding: 43px 105px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        border-radius: 40px;
        border: 1px solid #DBDBDB;
        background: #F5F5F5;
    }

    
    
`;

export const bookListCss = css`

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
    align-self: stretch;
/*    margin : 0 auto;*/
    
    
    .bookListGrid {
        display: flex;
        width: 100%;
        justify-content: center;
        gap: 60px 89px;
        flex-wrap: wrap;
    }

`;


export const AuthorDetailCss = css`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 40px;
    
    .profileWrap  {
        display: flex;
        align-items: center;
        gap: 350px;
    }

    .profile {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 40px;
        position: relative;
    }

    .profileImg {
        position: absolute;
        width: 280px;
        height: 280px;
      /*  object-fit: cover;*/
        border-radius: 50%;
        background: #F9F9F9;
        top: -150px; 
        z-index: 10;
        overflow: hidden;
        filter: shadow(4px 4px 10px rgba(0, 0, 0, 0.10));
        
    }
    
`;




export const AuthorListCss = css`
    display: flex;
    /*width: 1200px;*/
    min-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    margin: 0 auto;
    gap: 62px;

   
    .listBox {
        display: flex;
        flex-direction: column;
        gap: 24px;
        /*width: 359px;*/
    }

    .filter {
        display: flex;
        flex-direction: row;
        gap: 12px;
        width: 100%;
        height: 100%;
    }
    
    .authorList {
        display: flex;
        padding: 30px 27px;
        align-items: flex-start;
        gap: 22px;
        border-radius: 30px;
        border: 1px solid #D2D2D2;
        background: #FFF;
        box-shadow: 1px 2px 6px 0px rgba(0, 0, 0, 0.12);
    }

    
`;
